<template>
    <header>
        <div class="logo__cell">
            <img :src="logo" class="logo">
        </div>
        <div class="innobun__logo_cell">
            <img src="/src/img/innobun_fortisa.svg" class="innobun-logo">
            <h2>{{ title }}</h2>
        </div>
    </header>
</template>

<script>
    import StepIndicator from "./StepIndicator";
    export default {
        name: "PromptHeader",
        components: {StepIndicator},
        props: {
            'title': {
                type: String,
                default: ''
            },
            'step': {
                type: Number,
                default: 1
            }
        },
        computed: {
            logo: function () {
                return this.$store.getters.logo;
            }
        }
    }
</script>
